export const selectCenterId = state => state.auth.selectedCenter.id

export const providerDatesAlerts = state => state.delivery.providerDatesAlerts
